var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBed = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5 6.5A1.5 1.5 0 0 1 6.5 5h11c.813 0 1.5.688 1.5 1.5v3.938c-.469-.22-.969-.376-1.5-.407V9c0-.531-.469-1-1-1h-3c-.563 0-1 .469-1 1v1h-1V9c0-.531-.469-1-1-1h-3c-.563 0-1 .469-1 1v1.031a3.803 3.803 0 0 0-1.5.406V6.5ZM6.75 11h10.5c1.5 0 2.75 1.25 2.75 2.75v4.5a.74.74 0 0 1-.75.75.722.722 0 0 1-.75-.75V17h-13v1.25a.74.74 0 0 1-.75.75.722.722 0 0 1-.75-.75v-4.5C4 12.25 5.219 11 6.75 11Zm11.75 4.5v-1.75c0-.688-.563-1.25-1.25-1.25H6.75c-.719 0-1.25.563-1.25 1.25v1.75h13Z",
  fill: "currentColor"
})));
export { SvgBed as ReactComponent };
export default __webpack_public_path__ + "1dddecbb77adff14a6e7531335e0f883.svg";